module.exports = __webpack_public_path__ + "img/ahkmenrahs_dad_merenkahre.8199291b.jpg";